var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"control colors"},_vm._l((_vm.colors),function(color,index){return _c('div',{key:'color-' + index,ref:'color-' + index,refInFor:true,class:{
        color: true,
        selected: _vm.value === color
      },on:{"click":function($event){return _vm.colorChanged(color)}}},[_c('span',{style:({ background: color })})])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }